import styled from 'styled-components';

const HeaderText = styled.h1`
    font-size: 1.125rem;
    font-weight: 400;
    line-height: 1.5rem;
    letter-spacing: 0.0125rem;
    color: rgb(10, 9, 18);
`;

export default HeaderText;
